module.exports = __webpack_public_path__ + "img/tmx_hr_video_cover.323228d0.jpg";